import React, { TextareaHTMLAttributes } from 'react'

import * as s from './styles'

const TextArea: React.FC<React.TextareaHTMLAttributes<HTMLTextAreaElement>> = ({
  ...rest
}) => <s.Textarea {...rest} />

export default TextArea
